<template>
  <div class="statistic-widget-top-seller-product">
    <div class="card-header-tab card-header">
      <div class="card-header-title">Top Seller</div>
      <div class="btn-actions-pane-right scrollbar">
        <div role="group" class="btn-group-sm nav btn-group">
          <a v-for="currency in currencies" :key="currency.key" data-toggle="tab" href="#" :class="`btn-shadow btn btn-primary ${currency.key == selected ? 'active' : ''}`" @click.prevent="selected = currency.key">{{ currency.label }}</a>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="align-middle mb-0 table table-borderless table-striped table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th class="text-center">Number</th>
            <th class="text-center">Revenue</th>
            <th class="text-center">Funds</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in Object.values(data?.[selected]?.items || [])" :key="index">
            <td>
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">{{ item.user_name }}</div>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center">{{ item.number }}</td>
            <td class="text-center">
              {{ new Intl.NumberFormat().format(item.sale_price) }}
            </td>
            <td class="text-center">
              {{ new Intl.NumberFormat().format(item.purchase_price) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: null
    }
  },
  computed: {
    data() {
      return this.config?.data || {}
    },
    currencies() {
      let currencies = []
      Object.entries(this.data).forEach(([key, item]) => {
        currencies.push({
          key: key,
          label: `${item.sale_currency}-${item.purchase_currency || '$'}`,
          priority: item?.items?.[0]?.number
        })
      })
      currencies.sort((a, b) => {
        if ((a.priority || 0) - (b.priority || 0) > 0) {
          return -1
        } else if ((a.priority || 0) - (b.priority || 0) < 0) {
          return 1
        }
        return 0
      })

      return currencies
    }
  },
  watch: {
    currencies: {
      handler(values) {
        this.selected = values?.[0]?.key
      },
      immediate: true
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.statistic-widget-top-seller-product {
  .card-header {
    position: relative;
    padding: 0 15px;
    margin: -15px -15px 0 -15px;
    z-index: 99;
    text-transform: none;
    .card-header-title {
      padding-right: 20px;
    }
    .btn-actions-pane-right {
      overflow-x: auto;
      overflow-y: hidden;
    }
    .nav {
      display: block;
    }
  }
}
</style>
